import { render, staticRenderFns } from "./DoctorListPreview.vue?vue&type=template&id=0a6c0430&scoped=true&"
import script from "./DoctorListPreview.vue?vue&type=script&lang=js&"
export * from "./DoctorListPreview.vue?vue&type=script&lang=js&"
import style0 from "./DoctorListPreview.vue?vue&type=style&index=0&id=0a6c0430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c0430",
  null
  
)

export default component.exports